import * as React from 'react';

// libs
import { createUseStyles } from "react-jss";

// context
import { useStreamContext } from '../../context';

// ps
import { Config, PixelStreaming, Logger } from 'metaeditor4-ue';
import { Application } from 'metaeditor4-ui';
// import { PixelStreamingApplicationStyle } from 'metaeditor4-ui';
// export const PixelStreamingApplicationStyles = new PixelStreamingApplicationStyle();

// hooks
import useWindowSize from '../../hooks/useWindowSize'
import useStreamEvents from '../../hooks.stream/useStreamEvents'

// snippets
import Pleloader from '../Pleloader'
import Toolbar from '../Toolbar'
import Container from '../Container';

// types
import { PlayerConfigProps } from '../../context/useStreamContext/types'


const useStyles = createUseStyles({
  '@global': {
    '& body': {
      width: '100vw',
      height: 'var(--window-height)',
      overflow: 'hidden',
    },
    '#playOverlay': {
      display: 'none'
    },
    '#infoOverlay': {
      display: 'none'
    },
    '#disconnectOverlay': {
      display: 'none'
    },
    '#connection': {
      bottom: 'auto !important',
      left: 'auto !important',
      right: '2rem !important',
    },
    // '#controls': {
    //   top: 'var(--metaeditor-appbar-height) !important'
    // },
    // '#uiFeatures': {
    //   visibility: 'hidden'
    // }
  },

  rootDiv: {
    zIndex: 0,
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    width: '100vw',
    height: '100vh',
    minHeight: '-webkit-fill-available',
  },
})


export default function PlayerComponent(props: PlayerConfigProps) {

  const {
    showToolbar,
    psHost,
  } = props

  // context
  const streamContext = useStreamContext()

  // styles
  const styles = useStyles();

  // refs
  const refRoot = React.useRef<any>(null)

  // hooks
  useWindowSize()
  useStreamEvents()

  // effects
  React.useEffect(() => {
    streamContext.saveConfig(props)
  }, [props])

  React.useEffect(() => {

    // Example of how to set the logger level
    Logger.SetLoggerVerbosity(0);

    const initialSettings = {
      AutoPlayVideo: false || props.autoPlay,
      AutoConnect: true || props.autoConnect,
      ss: psHost,
      StartVideoMuted: true || props.startMuted,
      HoveringMouse: true || props.hoveringMouse,
      FakeMouseWithTouches: true || props.fakeMouseWithTouches,
      MatchViewportRes: true || props.matchViewportRes,
    }

    // Create a config object
    const config = new Config({
      useUrlParams: true,
      initialSettings,
    });

    // Create a Native DOM delegate instance that implements the Delegate interface class
    const stream = new PixelStreaming(config);
    const application = new Application({ stream });

    if (refRoot.current && !refRoot.current.textContent) {
      // (window as any).stream = stream as object
      (window as any).player = application
      refRoot.current!.appendChild(application.rootElement)
    }

  }, [])

  // Show/hide ui
  React.useEffect(() => {
    document.getElementById("uiFeatures").style.visibility = showToolbar ? 'visible' : 'hidden'
  }, [showToolbar])

  return (
    <>

      <Pleloader />

      <Toolbar show={showToolbar} />

      <div ref={refRoot} className={styles.rootDiv} />

      {props.children ? (
        <Container>
          {props.children}
        </Container>
      ) : ''}

    </>
  );
}
